import { createFileRoute, redirect } from "@tanstack/react-router";
import { AppShell } from "@/components/layout/AppShell";
import type { RouterContext } from "@/lib/router-context";

export const Route = createFileRoute("/_app")({
  beforeLoad: async ({ context, location }) => {
    const ctx = context as RouterContext;
    const session = await ctx.ensureSession();
    if (!session) {
      throw redirect({
        to: "/auth",
        search: {
          redirect: location.href
        }
      });
    }

    if (!session.onboardingComplete && location.pathname !== "/settings/billing") {
      throw redirect({
        to: "/onboarding",
        search: (prev: any) => prev
      });
    }
  },
  component: AppShell
});
